/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ProblemDetail,
  ReferenceListReasonsParams,
  ReturnReasonCreate,
  ReturnReasonOut,
  ReturnReasonUpdate
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType , BodyType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Причины возврата (короткий справочник, без пагинации)
 */
export const referenceListReasons = (
    params?: ReferenceListReasonsParams,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<ReturnReasonOut[]>(
      {url: `/api/v1/return-reasons`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getReferenceListReasonsQueryKey = (params?: ReferenceListReasonsParams,) => {
    return [
    `/api/v1/return-reasons`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReferenceListReasonsQueryOptions = <TData = Awaited<ReturnType<typeof referenceListReasons>>, TError = ErrorType<ProblemDetail>>(params?: ReferenceListReasonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referenceListReasons>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReferenceListReasonsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof referenceListReasons>>> = ({ signal }) => referenceListReasons(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof referenceListReasons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReferenceListReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof referenceListReasons>>>
export type ReferenceListReasonsQueryError = ErrorType<ProblemDetail>


export function useReferenceListReasons<TData = Awaited<ReturnType<typeof referenceListReasons>>, TError = ErrorType<ProblemDetail>>(
 params: undefined |  ReferenceListReasonsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof referenceListReasons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof referenceListReasons>>,
          TError,
          Awaited<ReturnType<typeof referenceListReasons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReferenceListReasons<TData = Awaited<ReturnType<typeof referenceListReasons>>, TError = ErrorType<ProblemDetail>>(
 params?: ReferenceListReasonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referenceListReasons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof referenceListReasons>>,
          TError,
          Awaited<ReturnType<typeof referenceListReasons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReferenceListReasons<TData = Awaited<ReturnType<typeof referenceListReasons>>, TError = ErrorType<ProblemDetail>>(
 params?: ReferenceListReasonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referenceListReasons>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Причины возврата (короткий справочник, без пагинации)
 */

export function useReferenceListReasons<TData = Awaited<ReturnType<typeof referenceListReasons>>, TError = ErrorType<ProblemDetail>>(
 params?: ReferenceListReasonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referenceListReasons>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReferenceListReasonsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create Reason
 */
export const referenceCreateReason = (
    returnReasonCreate: BodyType<ReturnReasonCreate>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<ReturnReasonOut>(
      {url: `/api/v1/return-reasons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: returnReasonCreate, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getReferenceCreateReasonMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referenceCreateReason>>, TError,{data: BodyType<ReturnReasonCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof referenceCreateReason>>, TError,{data: BodyType<ReturnReasonCreate>}, TContext> => {

const mutationKey = ['referenceCreateReason'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof referenceCreateReason>>, {data: BodyType<ReturnReasonCreate>}> = (props) => {
          const {data} = props ?? {};

          return  referenceCreateReason(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReferenceCreateReasonMutationResult = NonNullable<Awaited<ReturnType<typeof referenceCreateReason>>>
    export type ReferenceCreateReasonMutationBody = BodyType<ReturnReasonCreate>
    export type ReferenceCreateReasonMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Create Reason
 */
export const useReferenceCreateReason = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referenceCreateReason>>, TError,{data: BodyType<ReturnReasonCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof referenceCreateReason>>,
        TError,
        {data: BodyType<ReturnReasonCreate>},
        TContext
      > => {

      const mutationOptions = getReferenceCreateReasonMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update Reason
 */
export const referenceUpdateReason = (
    reasonId: number,
    returnReasonUpdate: BodyType<ReturnReasonUpdate>,
 options?: SecondParameter<typeof apiRequest>,) => {
      
      
      return apiRequest<ReturnReasonOut>(
      {url: `/api/v1/return-reasons/${reasonId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: returnReasonUpdate
    },
      options);
    }
  


export const getReferenceUpdateReasonMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referenceUpdateReason>>, TError,{reasonId: number;data: BodyType<ReturnReasonUpdate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof referenceUpdateReason>>, TError,{reasonId: number;data: BodyType<ReturnReasonUpdate>}, TContext> => {

const mutationKey = ['referenceUpdateReason'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof referenceUpdateReason>>, {reasonId: number;data: BodyType<ReturnReasonUpdate>}> = (props) => {
          const {reasonId,data} = props ?? {};

          return  referenceUpdateReason(reasonId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReferenceUpdateReasonMutationResult = NonNullable<Awaited<ReturnType<typeof referenceUpdateReason>>>
    export type ReferenceUpdateReasonMutationBody = BodyType<ReturnReasonUpdate>
    export type ReferenceUpdateReasonMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Update Reason
 */
export const useReferenceUpdateReason = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referenceUpdateReason>>, TError,{reasonId: number;data: BodyType<ReturnReasonUpdate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof referenceUpdateReason>>,
        TError,
        {reasonId: number;data: BodyType<ReturnReasonUpdate>},
        TContext
      > => {

      const mutationOptions = getReferenceUpdateReasonMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    